// Benchmark rung names on screen. The English names ('your best weeks', 'peer cohort',
// …) are DATA: prioritization/gauges.js + ladder.js and the backend signals emit them,
// parity tests compare them and components test them with ===, so they never change.
// Only what the reader SEES goes through here. English shows the same name as always;
// Dutch follows docs/reference/dutch_glossary.md §5.
import { i18n } from './index.js'

const KEY_BY_NAME = {
  'your best weeks': 'bestWeeks',
  'your best zones': 'bestZones',
  'your peers': 'yourPeers',
  'peer cohort': 'peerCohort',
  'best-in-class': 'bic',
}

// rungLabel('your best weeks') -> 'your best weeks' | 'je beste weken'.
// form 'in' gives the name as it follows "than" / "as" in a sentence
// ('in je beste weken', 'bij best-in-class'); English is the same name.
// Unknown names show as given.
export function rungLabel(name, { form = 'plain' } = {}) {
  const k = KEY_BY_NAME[name]
  if (!k) return name
  const key = `gauges.${form === 'in' ? 'rungsIn' : 'rungs'}.${k}`
  return i18n.global.te(key) ? i18n.global.t(key) : name
}
